module.exports = __webpack_public_path__ + "img/3e8a2cb.png";